import React, { useEffect, useState } from "react"
import { ProductCarousel } from "../../components/product-carousel"
import { SearchspringRecommendProvider } from "@app/scripts/providers/searchspring"
import { RvsiItem } from "@app/types"

export type Props = {
  rvsiData: RvsiItem[]
}

export function RecentlyViewedSimilarItems({ rvsiData }: Props) {
  const [selectedCarousel, setSelectedCarousel] = useState("")
  const [carouselData, setCarouselData] = useState(rvsiData)

  useEffect(() => {
    const validCarousel = carouselData.find((item) => item.count > 0)
    if (validCarousel) {
      setSelectedCarousel(validCarousel.profileTag)
    }
  }, [carouselData])

  return (
    <div className="ss-rvsi--container">
      {/* Tabs */}
      <div className="rvsi-tabs--container">
        {carouselData.map(({ heading, profileTag, count }) => {
          if (count === 0) return null

          return (
            <button
              key={profileTag}
              onClick={() => setSelectedCarousel(profileTag)}
              className={`rvsi-button ${selectedCarousel === profileTag ? "active" : ""}`}
            >
              {heading}
              <span
                className={`rvsi-button--underline ${selectedCarousel !== profileTag ? "is-hidden" : ""}`}
              />
            </button>
          )
        })}
      </div>

      <div className="rvsi-carousel--container">
        {/* Render all carousels but only show active one */}
        {rvsiData.map(({ profileTag, productSku }, index) => {
          return (
            <SearchspringRecommendProvider
              key={profileTag}
              profile={profileTag || ""}
              products={productSku || ""}
              limit={8}
            >
              <ProductCarousel
                visible={selectedCarousel === profileTag}
                position={index !== 1 ? "relative" : "absolute"}
                carouselName={profileTag}
                setCarouselData={setCarouselData}
              />
            </SearchspringRecommendProvider>
          )
        })}
      </div>
    </div>
  )
}
